import React from "react";
// import { useChatState } from "../context/ChatStateContext";
import logo from "@/assets/logo.png";
import { useStyles } from "./styles";

interface Props {
  welcome?: React.ReactNode;
}

const Welcome: React.FC<Props> = ({ welcome }) => {
  // const { appInfo } = useChatState();
  const styles = useStyles();

  if (welcome) return <>{welcome}</>;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        textAlign: "center",
      }}
    >
      <img src={logo} style={{ width: "80px", height: "80px" }} />
      <h2 className={styles.logoText}>Hi, 有什么我能帮您的吗？</h2>
    </div>
  );
};

export default Welcome;
